import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useNavigate,
} from "react-router-dom";
import Loader from "./Loader";
import DashBoard from "./DashBoard";
import TablePage from "./TablePage";
import ManageSetting from "./ManageSetting";
import MainLayout from "./shared/MainLayout";
import RiskTable from "./RiskTable";
import DetailsNew from "./DetailsNew";

import { Toaster } from "react-hot-toast";
import Forbidden from "./Forbidden";
import CountryTable from "./CountryTable";
import OnboardingResult from "./results/OnboardingResult";
import OnboardingDetailsNew from "./OnboardingCalc";
import InvestmentResult from "./results/InvestmentResult";
import InvestmentDetailsNew from "./InvestmentCalc";
import Footer from "./components/Foorter";
import CorporateDetails from "./CorporateDetails";
import KYBRiskTable from "./KYBRiskTable";
import TrustDetails from "./TrustDetails";
import TrustRiskTable from "./TrustRiskTable";
import FoundationDetails from "./FoundationDetails";
import FoundationRiskTable from "./FoundationRiskTable";
const Redirector = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setLoading(false);
      navigate("/details");
    }, 7000); // Show loader for 7 seconds

    return () => clearTimeout(timeout); // Clean up timeout on unmount
  }, [navigate]);

  if (loading) {
    return <Loader duration="5s" />;
  }

  return null;
};
// window.addEventListener("unload", function () {
//   // Clear all localStorage data
//   localStorage.clear();
// });

if (window.location.href.split("/")[4] && window.location.href.split("/")[5]) {
  localStorage.setItem(
    "token",
    window.location.href.split("/")[4].split("&")[0]
  );
  localStorage.setItem(
    "kycID",
    window.location.href.split("/")[5].split("&")[0]
  );
  localStorage.setItem("envrioment", window.location.href.split("&env=")[1]);
}

const App = () => {
  return (
    <>
      <Toaster position="top-center" reverseOrder={false} />
      <Router>
        <Routes>
          <Route path="/" element={<Redirector />} />
          <Route element={<MainLayout />}>
            {" "}
            {/* Layout route */}
            {/* <Route path="/kyc-details" element={<Details />} /> */}
            <Route path="/dashboard/*" element={<DashBoard />} />
            <Route path="/manage-setting" element={<ManageSetting />} />
            <Route path="/table/*" element={<TablePage />} />
            <Route path="/country-table/*" element={<CountryTable />} />
          </Route>
          <Route path="/details/*" element={<DetailsNew />} />

          <Route path="/corporate-details/*" element={<CorporateDetails />} />
          <Route path="/trust-details/*" element={<TrustDetails />} />
          <Route path="/foundation-details/*" element={<FoundationDetails />} />

          <Route path="/corporate-risk-table" element={<KYBRiskTable />} />
          <Route path="/trust-risk-table" element={<TrustRiskTable />} />
          <Route
            path="/foundation-risk-table"
            element={<FoundationRiskTable />}
          />

          <Route
            path="/onboarding-details/*"
            element={<OnboardingDetailsNew />}
          />
          <Route
            path="/investment-details/*"
            element={<InvestmentDetailsNew />}
          />
          <Route path="/risk-table" element={<RiskTable />} />

          <Route path="/onboarding-risk-table" element={<OnboardingResult />} />

          <Route path="/investment-risk-table" element={<InvestmentResult />} />
          <Route path="/forbidden" element={<Forbidden />} />
        </Routes>
      </Router>
      {/* <Footer /> */}
    </>
  );
};

export default App;
